<script setup>
import { __ } from '@/utils';
import { inject, ref } from 'vue';
import Hint from '@components/hint.vue';
import IconPhones from '@components/icons/icon-phones.vue';
import IconEsimDark from '@components/icons/icon-esim-dark.vue';
import IconEsim from '@components/icons/icon-esim.vue';

const props = defineProps(['phone']);
const { setStep, response } = inject('form');


const days = [
    __('Sunday'),
    __('Monday'),
    __('Tuesday'),
    __('Wednesday'),
    __('Thursday'),
    __('Friday'),
    __('Saturday'),
];

const portingTime = response.value?.subscribers?.[0]?.porting_time;

const handleDate = (minutes = false) => {
    const date = new Date(portingTime);
    if(minutes) {
        date.setMinutes(date.getMinutes() + minutes);
    }
    const day = days[date.getDay()];
    const time = date.getHours() + ":" + ("0" + date.getMinutes()).slice(-2);

    return {
        day,
        time
    }
}

const currentDate = handleDate();
const dateAfter15Minutes = handleDate(15);

const esimAndroid = ref(simPdfGuilds.esim_android);
const esimIOS = ref(simPdfGuilds.esim_ios);
const htmlText = ref(simPdfGuilds.esim_porting_text)
const htmlTopText = ref(simPdfGuilds.esim_porting_line_top)
</script>
<template>
    <div class="congrats">
        <div class="congrats__inner">
            <IconEsim width="70px" />
            <div class="congrats__heading">
                <h3 class="gradient">{{ __('Your eSIM has been activated successfully!') }}</h3>
            </div>

            <div class="congrats__order-number">
                <p>
                    <strong>{{ __('line number') }} {{ props.phone }}</strong>
                </p>
            </div>
            <h4>{{ __('So what happens now?') }}</h4>
            <div class="sim-steps sim-steps--space">
                <div class="sim-step">
                    <div class="sim-step__arrow">
                        <span></span>
                    </div>
                    <h3 class="gradient">01</h3>
                    <div class="sim-step__image">
                        <img :src="`${theme_path.url}/resources/images/svg/icon-smarthphone.svg`" />
                    </div>
                    <h5>
                        {{ __('The mobility process will begin on the day') }} {{ currentDate.day }}<br />
                        {{ __('at') }} {{ currentDate.time }}
                    </h5>

                </div>
                <div class="sim-step">
                    <div class="sim-step__arrow">
                        <span></span>
                    </div>
                    <h3 class="gradient">02</h3>
                    <div class="sim-step__image">
                        <IconPhones />
                    </div>
                    <h5>
                        {{ __('The mobility process is about to end') }}<br />
                        {{ __('on') }} {{ dateAfter15Minutes.day }} {{ __('at') }} {{ dateAfter15Minutes.time }}
                    </h5>
                </div>
                <div class="sim-step">
                    <h3 class="gradient">03</h3>
                    <div class="sim-step__image">
                        <IconEsimDark />
                    </div>
                    <span dir="rtl" v-html="htmlTopText"></span>
                </div>
            </div>

            <h5 class="fz18"><strong>{{ __('Still struggling? Use our guides') }}</strong></h5>

            <div class="guide-cta mb13">
                <div class="guide-cta__item">
                    <Hint />
                    <a :href="esimAndroid" target="_blank" v-if="esimAndroid">
                        {{ __('Android Guide') }}
                    </a>
                </div>
                <div class="guide-cta__item">
                    <Hint />
                    <a :href="esimIOS" target="_blank" v-if="esimIOS">
                        {{ __('IOS Guide') }}
                    </a>
                </div>
            </div>
            <div class="congrats__text-content">
                <span dir="rtl" v-html="htmlText"></span>
            </div>
            <div class="success-cta-row">
                <a href="/activation" class="link-arrow link-arrow--dark" @click.prevent="setStep('initial')">
                    {{ __('Click to activate another SIM') }}
                </a><!-- /.btn -->
                <a href="/" class="btn btn--arrows w156">{{ __('Back to Home page') }}</a>
            </div>
        </div>
    </div>
</template>